import React from 'react';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { formatPrice } from '../utils/helpers';

const num = (v) => (v === '' || v === null || v === undefined ? null : parseFloat(v));

export const PricingCard = ({ price, compare, cost, stock, onChange, showStock = true }) => {
  const p = num(price), c = num(compare), k = num(cost);
  const discount = p && c && c > p ? Math.round(((c - p) / c) * 100) : 0;
  const margin = p && k !== null ? p - k : null;
  return (
    <div className="rounded-xl border bg-gray-50 p-4 space-y-3" data-testid="pricing-card">
      <p className="text-sm font-semibold text-gray-700">Precios</p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div>
          <Label className="text-xs text-gray-600 mb-1 block">Costo (privado)</Label>
          <Input type="number" min="0" value={cost} onChange={e => onChange('cost_price', e.target.value)} placeholder="Opcional" data-testid="wizard-cost-price" />
        </div>
        <div>
          <Label className="text-xs text-gray-600 mb-1 block">Precio de venta (MXN) *</Label>
          <Input type="number" min="0" value={price} onChange={e => onChange('price', e.target.value)} placeholder="9999" className="font-semibold" data-testid="wizard-price" />
        </div>
        <div>
          <Label className="text-xs text-gray-600 mb-1 block">Precio de comparación ("antes")</Label>
          <Input type="number" min="0" value={compare} onChange={e => onChange('compare_at_price', e.target.value)} placeholder="Opcional" data-testid="wizard-compare-price" />
        </div>
      </div>
      {showStock && (
        <div className="sm:w-1/3">
          <Label className="text-xs text-gray-600 mb-1 block">Stock *</Label>
          <Input type="number" min="0" value={stock} onChange={e => onChange('stock', e.target.value)} placeholder="10" data-testid="wizard-stock" />
        </div>
      )}
      <div className="flex flex-wrap gap-3 text-xs" data-testid="pricing-summary">
        {c !== null && p && c <= p && <span className="text-amber-700">El precio de comparación debe ser mayor al de venta para mostrarse como oferta.</span>}
        {discount > 0 && <span className="px-2 py-0.5 rounded-full bg-red-100 text-red-700 font-semibold">Oferta -{discount}%</span>}
        {margin !== null && (
          <span className={margin >= 0 ? 'text-emerald-700' : 'text-red-600'}>
            Ganancia por unidad: {formatPrice(margin)}{p ? ` (${Math.round((margin / p) * 100)}%)` : ''} · solo tú la ves
          </span>
        )}
      </div>
    </div>
  );
};
